import { Injectable } from '@angular/core';
import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { TcsConfigurationService } from 'src/app/core/configuration.service';
import { uuid } from 'src/util/uuid';

const tabId = uuid();

export interface NewRelicConfiguration {
  enabled: boolean;
  loaderConfig: NewRelicLoaderConfig;
}

export interface NewRelicLoaderConfig {
  accountID: string;
  trustKey: string;
  agentID: string;
  licenseKey: string;
  applicationID: string;
}

function initializeTelemetry(newRelic: BrowserAgent) {
  // Set Custon Attributes

  // Add tab ID
  newRelic.setCustomAttribute('tabId', tabId);

  // Set cloud_roleName
  newRelic.setCustomAttribute('roleName', 'website');

  // Always include current href
  newRelic.setCustomAttribute('href', window.location.href);

  // TO DO:

  // Do we need to use setCurrentRouteName?
  // https://docs.newrelic.com/docs/browser/new-relic-browser/browser-apis/setcurrentroutename/
  // newRelic.setCurrentRouteName()

  // Do we need these additional attributes utilized in Application Insights?
  // ? Set operation ID
  // ? Don't track network exceptions
  // ? Don't automatically track GraphQL dependencies (we do that manually)
}

@Injectable({ providedIn: 'root' })
export class NewRelicService {
  public newRelic: BrowserAgent | undefined;
  private _initialized$ = new BehaviorSubject(false);
  constructor(private _config: TcsConfigurationService) {}

  get intialized$(): Observable<boolean> {
    return this._initialized$.asObservable().pipe(filter((init) => init));
  }

  public init() {
    if (this._initialized$.getValue()) {
      return;
    }

    if (this._config.value.newRelic.enabled === true) {
      const options = {
        init: {
          distributed_tracing: {
            enabled: true,
            cors_use_newrelic_header: true,
            cors_use_tracecontext_headers: true,
            allowed_origins: [this._config.value.tcs.graphqlUri],
          },
          privacy: { cookies_enabled: true },
          ajax: { deny_list: ['bam.nr-data.net'] },
        },
        info: {
          beacon: 'bam.nr-data.net',
          errorBeacon: 'bam.nr-data.net',
          licenseKey: this._config.value.newRelic.loaderConfig.licenseKey,
          applicationID: this._config.value.newRelic.loaderConfig.applicationID,
          sa: 1,
        },
        loader_config: this._config.value.newRelic.loaderConfig,
      };
      this.newRelic = new BrowserAgent(options);

      initializeTelemetry(this.newRelic);

      this._initialized$.next(true);
    }
  }
}
